import { Avatar, Button, List, Tooltip } from 'antd';
import React from 'react';

import Buy from 'api/models/Engines/Buy';

type Props = {
	items: Buy[];
};

const BuysList = ({ items }: Props) => {
	return (
		<List
			itemLayout="horizontal"
			dataSource={items.filter((item) => item.good_id)}
			renderItem={(item) => {
				const isModule = item.good_type === 'Модуль';
				const link = `https://gamecms.ru/${isModule ? 'module' : 'template'}?id=${item.good_id}`;
				const screen = `https://gamecms.ru/${item.good_screens.split(';')[0]}`;

				return (
					<List.Item
						actions={[
							<a target="_blank" href={link} key="1" rel="noreferrer">
								<Button>Открыть в каталоге</Button>
							</a>,
						]}
					>
						<List.Item.Meta
							avatar={
								<Avatar shape="square" size={70} src={screen}>
									{item.good_type}
								</Avatar>
							}
							title={<Tooltip title={item.good_description}>{item.good_name}</Tooltip>}
							description={
								<>
									Тип: {item.good_type} <br />
									Ключ: {item.key}
								</>
							}
						/>
					</List.Item>
				);
			}}
		/>
	);
};

export default BuysList;
